export enum CREATION_TYPE {
    Rega = "REGA",
    Saeei = "SAEEI"
}